export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ14.66c3729e.mp3";